// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m915vq{overflow-y:hidden}
._18u01b66{margin-left:var(--ds-space-050,4px)}
._1bsbgktf{width:20px}
._1bto1l2s{text-overflow:ellipsis}
._1reo15vq{overflow-x:hidden}
._1ul9gktf{min-width:20px}
._4t3igktf{height:20px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/common/modal/popup-select/formatOptionLabel.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,mCAAmC;AAC9C,WAAW,UAAU;AACrB,WAAW,sBAAsB;AACjC,WAAW,iBAAiB;AAC5B,WAAW,cAAc;AACzB,WAAW,WAAW","sourcesContent":["._18m915vq{overflow-y:hidden}\n._18u01b66{margin-left:var(--ds-space-050,4px)}\n._1bsbgktf{width:20px}\n._1bto1l2s{text-overflow:ellipsis}\n._1reo15vq{overflow-x:hidden}\n._1ul9gktf{min-width:20px}\n._4t3igktf{height:20px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
